export interface IResultsWithCount<T> {
  results: T[];
  count: number;
}
